export default "/images/logo.svg?e08c399081822db9a98540d5f83ed2ea";